import { useCallback, useMemo } from 'react';
import Cookies from 'universal-cookie';

const useCookie = serverCookie => {
  const cookies = useMemo(() => new Cookies(serverCookie || null), [
    serverCookie,
  ]);

  const getCookie = useCallback(key => cookies.get(key) || null, [cookies]);

  const getCookieAll = useCallback(() => cookies.getAll() || null, [cookies]);

  const setCookie = useCallback(
    (key, value, options = {}) => {
      const cookieMaxAge = 60 * 60 * 24 * 10; // cookie lifetime 10 days
      cookies.set(key, value, {
        maxAge: options.maxAge || cookieMaxAge,
        path: '/',
        ...options,
      });
    },
    [cookies]
  );

  const removeCookie = useCallback(
    key => {
      cookies.remove(key);
    },
    [cookies]
  );

  return {
    getCookie,
    getCookieAll,
    setCookie,
    removeCookie,
  };
};

export default useCookie;
